module.exports = __webpack_public_path__ + "static/media/homeitem3.4196f6ae.png";